import type { BaseState, ServiceAppState, Translation } from '@kc-console/context';
import type { GuardParams } from './middlewares';

interface SyncI18nResourcesBaseProps {
  namespace: string;
  queryClient: GuardParams['queryClient'];
  guard?: string;
  languages?: string[];
}

export interface SyncI18nResourcesWithLocaleProps extends SyncI18nResourcesBaseProps {
  locale: string;
  context?: GuardParams['context'];
  state?: never;
}

export interface SyncI18nResourcesWithStateProps extends SyncI18nResourcesBaseProps {
  context: GuardParams['context'];
  state: ServiceAppState & BaseState;
  locale?: never;
}

export type SyncI18nResourcesProps =
  | SyncI18nResourcesWithLocaleProps
  | SyncI18nResourcesWithStateProps;

/** namespace → (language → Translation) 매핑 */
export type TranslationMap = Map<string, Record<string, Translation>>;

export interface BuildInitialI18nStoreProps {
  languages: string[];
  namespaces: string[];
  translationMap: TranslationMap;
}

/** 런타임 Translation 타입 가드 */
export function isTranslation(value: unknown): value is Translation {
  if (typeof value !== 'object' || value === null) return false;

  const checkValue = (val: unknown): boolean => {
    if (typeof val === 'string') return true;
    if (typeof val === 'object' && val !== null) {
      return Object.values(val).every(v => checkValue(v));
    }
    return false;
  };

  return Object.values(value).every(v => checkValue(v));
}
